<template>
  <div class="footer-module">
    <div class="empty"></div>
    <div class="footer-images">
      <div class="center-box">
        <img class="qiniu-img" src="https://www-static.qbox.me/sem/pili-live-1001/source/img/qiniu.png" alt="" />
        <span>企业直播，选七牛云！免费领取价值 999 元试用资格</span>
        <div @click="toClient()" class="footer-button">立即领取</div>
      </div>
    </div>
    <div class="bottom-text">
      <div class="copyright-box">
        <img
          @click="toQiniuOfficial()"
          src="https://www-static.qbox.me/sem/pili-live-1001/source/img/qiniu_logo-1.png"
          alt=""
        />
        <div class="text-box">
          <span>Copyright © 2011-2023 Qiniu Cloud.</span>
          <span>产品及服务咨询：400-808-9176 转 1</span>
        </div>
      </div>
      <div class="other-text">
        <span @click="toBeian()">沪公网安备31011502000961号</span>
        <span @click="toBeian()">沪ICP备11037377号-5</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "footerModule",
  props: {
    msg: String,
  },
  data() {
    return {};
  },
  methods: {
    toClient() {
      window.open(
        "https://affim.baidu.com/unique_53498961/chat?siteId=20774082&userId=53498961&siteToken=35708c2ed9714876a5578566862942da&cp=https%3A%2F%2Fwww.qiniu.com%2Fsem%2Fpili-live-1001%2Findex.html&cr=&cw=%E4%B8%83%E7%89%9B%E5%AE%98%E7%BD%91%E4%BC%81%E4%B8%9A%E7%9B%B4%E6%92%AD%E8%AF%A6%E6%83%85%E9%A1%B5"
      );
    },
    toBeian() {
      window.open("https://beian.miit.gov.cn/#/Integrated/index");
    },
    toQiniuOfficial() {
      window.open("https://www.qiniu.com/");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.footer-module {
  width: 100%;
  height: 297px;
  min-width: 1440px;
  position: relative;
  display: flex;
  background: #fff;
  flex-direction: column;
  align-items: center;
  .empty {
    width: 100%;
    height: 64px;
  }
  .footer-images {
    width: 100%;
    height: 80px;
    background-image: url("https://www-static.qbox.me/sem/pili-live-1001/source/img/footer.png");
    background-repeat: no-repeat;
    background-size: cover;
    display: flex;
    flex-direction: row;
    align-items: center;
    font-family: PingFang SC;
    font-weight: 500;
    letter-spacing: 0em;
    color: #fff;
    justify-content: center;
    .center-box {
      height: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      position: relative;
      .qiniu-img {
        position: absolute;
        left: 0;
        top: -64px;
        width: 150px;
        height: 160px;
      }
      span {
        font-size: 28px;
        line-height: 42px;
        text-align: left;
        margin-left: 180px;
      }
      .footer-button {
        font-size: 20px;
        width: 154px;
        height: 46px;
        text-align: center;
        border-radius: 26px;
        line-height: 46px;
        background: linear-gradient(90deg, #f9b34c 0%, #ff7729 100%);
        cursor: pointer;
        &:hover {
          opacity: 0.9;
          transition: opacity 0.3s ease-in-out;
          // transform: scale(1.1);
        }
      }
    }

    @media screen and (min-width: 1441px) {
      .center-box{
        justify-content: space-between;
        width: 1280px;
      }

    }
    @media screen and (max-width: 1440px) {
      .center-box{
        justify-content: space-between;
        width: 1152px;
      }

    }
  }
  .bottom-text {
    width: 100%;
    padding: 24px 0;
    height: 105px;
    background: #2c3138;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    z-index: 1;
    .copyright-box {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      height: 63px;
      img {
        cursor: pointer;
        width: 88px;
        height: 25px;
      }
      .text-box {
        display: flex;
        flex-direction: row;
        span {
          padding: 0 6px;
          font-family: PingFang SC;
          font-size: 14px;
          font-weight: 400;
          line-height: 22px;
          letter-spacing: 0em;
          text-align: left;
          color: #fff;
        }
      }
    }
    .other-text {
      width: 350px;
      height: 22px;
      opacity: 0.7px;
      color: #eeeeee;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      font-family: PingFang SC;
      font-size: 14px;
      font-weight: 400;
      line-height: 22px;
      letter-spacing: 0em;
      text-align: left;
      span {
        cursor: pointer;
        &:hover {
          color: #07beff;
        }
      }
    }
  }
}
</style>
